/** Email format check shared by every email field; allows any TLD of two or more letters (e.g. .global). */
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
